	export enum NoteStatusEnum {
		New = 1,
		Completed = 2,
		Migrated = 3
	}
